import { SiteLogo } from '@/components/layout/SiteLogo'
import { useWebsiteContact } from '@/services/httpServices/queries/useWebsite'

/**
 * Exact reproduction of the template's Bootstrap offcanvas sidebar
 * (#offcanvas-sidebar). The `.mobile-menu` container is populated by meanmenu.
 */
export function Offcanvas() {
  const { contact } = useWebsiteContact()
  const phoneHref = `tel:${contact.phone.replace(/[^\d+]/g, '')}`

  return (
    <div
      className="offcanvas offcanvas-end"
      data-bs-scroll="true"
      tabIndex={-1}
      id="offcanvas-sidebar"
      aria-labelledby="offcanvas-sidebar"
    >
      {/* offcanvas header start */}
      <div className="offcanvas-header">
        <div className="offcanvas-logo">
          <figure>
            <SiteLogo />
          </figure>
        </div>
        <button
          type="button"
          className="offcanvas-close bg-transparent"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        >
          <i className="fa-solid fa-xmark"></i>
        </button>
      </div>
      {/* offcanvas header end */}

      {/* offcanvas body start */}
      <div className="offcanvas-body">
        {/* menu outer start */}
        <div className="mobile-menu">
          {/* Here menu will come automatically via javascript / same menu as in header */}
        </div>
        {/* menu outer end */}

        {/* offcanvas about start */}
        <div className="offcanvas-about d-none d-xl-block">
          <p>
            Fast Aid Hospital, Chauddagram is a 24/7 medical care and diagnostic centre serving the people of
            Chittagong with emergency care, outdoor consultation, diagnostics and specialist treatment.
          </p>
        </div>
        {/* offcanvas about end */}

        {/* offcanvas contact start */}
        <div className="offcanvas-contact">
          <div className="widget widget-contact">
            <div className="widget-title">
              <h3>Contact Info</h3>
            </div>
            <div className="widget-content">
              <div className="offcanvas-cta-item">
                <div className="offcanvas-cta-list">
                  <div className="offcanvas-cta-icon">
                    <i className="fa-solid fa-location-dot"></i>
                  </div>
                  <div className="offcanvas-cta-content">
                    <p>{contact.address}</p>
                  </div>
                </div>
                <div className="offcanvas-cta-list">
                  <div className="offcanvas-cta-icon">
                    <i className="fa-solid fa-envelope"></i>
                  </div>
                  <div className="offcanvas-cta-content">
                    <a href={`mailto:${contact.email}`}>{contact.email}</a>
                  </div>
                </div>
                <div className="offcanvas-cta-list">
                  <div className="offcanvas-cta-icon">
                    <i className="fa-solid fa-phone-volume"></i>
                  </div>
                  <div className="offcanvas-cta-content">
                    <a href={phoneHref}>{contact.phone}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* offcanvas contact end */}

        {/* offcanvas button wapper start */}
        <div className="offcanvas-button-wapper">
          <a href="/appointment" className="theme-button style-1" aria-label="Book Appointment">
            <span data-text="Book Appointment">Book Appointment</span>
            <i className="fa-solid fa-arrow-right"></i>
          </a>
        </div>
        {/* offcanvas button wapper end */}

        {/* offcanvas social start */}
        <div className="offcanvas-social">
          <div className="widget widget-social-media">
            <div className="widget-content">
              <ul className="social-icon">
                <li>
                  <a href="#" aria-label="instagram">
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a href="#" aria-label="facebook">
                    <i className="fa-brands fa-facebook-f"></i>
                  </a>
                </li>
                <li>
                  <a href="#" aria-label="twitter">
                    <i className="fa-brands fa-x-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="#" aria-label="pinterest">
                    <i className="fa-brands fa-pinterest-p"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* offcanvas-social end */}
      </div>
      {/* offcanvas body end */}
    </div>
  )
}
